module.exports = __webpack_public_path__ + "static/media/fileNameIcon.0c54be02.png";